import { rootLinks } from '../app/links';

const base = `${rootLinks.inner()}/mentorSessions`;

export const mentorSessionsLinks = {
  root: () => base,
  requestSession: () => `${base}/request`,
  pendingRequests: () => `${base}/pendingRequests`,
  sessionDetails: (sessionId: number, { tab }: { tab?: string } | undefined = {}) => {
    const search = tab ? new URLSearchParams({ tab }).toString() : '';
    return `${base}/${sessionId}${search ? `?${search}` : ''}`;
  },
};
